import { render, staticRenderFns } from "./MonthQuiz.vue?vue&type=template&id=8fa8659e&scoped=true&lang=pug&"
import script from "./MonthQuiz.vue?vue&type=script&lang=js&"
export * from "./MonthQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MonthQuiz.vue?vue&type=style&index=0&id=8fa8659e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa8659e",
  null
  
)

component.options.__file = "MonthQuiz.vue"
export default component.exports